import { isEmpty } from 'lodash-es';
import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import { getUser, getWorkspaceUser, setAmplitudeUserId } from 'wisestep-api';
import { IUserCoreContext } from 'wisestep-base';

import { getAuthToken } from '../../utils/token';

export const UserContext = createContext<IUserCoreContext | null>(null);

export default function UserContextProvider(props: PropsWithChildren<IUserCoreContext | null>) {
  const [user, setUser] = useState<IUserCoreContext | null>({
    userDTO: null,
    workspaceUser: null,
  });

  useEffect(() => {
    (async function () {
      let triggerState = false;
      const userState = { ...user };
      let workspaceUser: string[] = userState?.workspaceUser?.authorities ?? [];
      if (isEmpty(user?.workspaceUser)) {
        triggerState = true;
        const userReq = await getWorkspaceUser();
        workspaceUser = userReq.data.authorities;
        userState.workspaceUser = userReq.data;
      }
      if (
        !(workspaceUser.includes('ROLE_ADMIN') || workspaceUser.includes('ROLE_SUPER_ADMIN')) &&
        isEmpty(user?.userDTO) &&
        !isEmpty(getAuthToken())
      ) {
        triggerState = true;
        const userReq = await getUser();
        userState.userDTO = userReq.data;
      }
      triggerState && setUser({ ...userState });
      setAmplitudeUserId(user?.userDTO?.email ?? '');
    })();
  }, [user]);

  return <UserContext.Provider value={{ ...user, setUser }}>{props.children}</UserContext.Provider>;
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useAppState must be used within the AuthContextProvider');
  }
  return context;
}
